import { useParams, useSearchParams } from 'react-router-dom';
import URLParse from 'url-parse';

export function UrlValidate(url) {
    // check url is valid or not valid and
    const pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol (optional)
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$',
        'i'
    );

    if (!pattern.test(url)) {
        return null;
    }

    // If URL doesn't start with http:// or https://, add https:// at the beginning
    if (!url?.startsWith('https://') && !url?.startsWith('http://')) {
        return `https://${url}`;
    }

    return url;
}

function nullFilter(obj) {
    const nObj = {};

    Object.keys(obj).forEach((key) => {
        if (obj[key]) {
            // key Camel case to hyphen
            const nKey = key.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`);
            nObj[nKey] = obj[key];
        }
    });

    return nObj;
}

export function mkRelativeUrl(path, queryParams = {}) {
    const URL = new URLParse(window.location.href, true);
    URL.pathname = path;
    URL.query = { ...nullFilter(queryParams) };
    return URL.toString().split(URL.origin)[1];
}

export function getParentPath(path) {
    const URL = new URLParse(window.location.href, true);
    URL.pathname = path;
    return URL.toString().split(URL.origin)[1];
}
export const GetCurrentUrl = () => {
    const URL = new URLParse(window.location.href, true);
    return URL.toString().split(URL.origin)[1];
};
export const GetUrlQuery = () => {
    const URL = new URLParse(window.location.href, true);
    return URL.query;
};

export const GetSearchParams = (paramsName) => {
    const [searchParams] = useSearchParams();
    return searchParams.get(paramsName);
};

export const GetDynamicValue = (key) => {
    /// agency/8/:type
    const param = useParams();

    return param?.[key];
};

export default null;
